import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../../../Pages/DashboardVcoi/dashboardVcoi";
import RespondentsVcoi from "../../../Pages/RespondentsVcoi/RespondentsVcoi";
import VcoiManageAdminPermission from "../../../Pages/VcoiSiteContent/VcoiManageAdminPermission";
import VcoiManagePolicyContent from "../../../Pages/VcoiSiteContent/VcoiManagePolicyContent";
import VcoiManagePolicyContentHome from "../../../Pages/VcoiSiteContent/VcoiManagePolicyContentHome";
import VcoiManageFormLabels from "../../../Pages/VcoiSiteContent/VcoiManageFormLabels";
import VcoiAddNewFormLevel from "../../../Pages/VcoiSiteContent/VcoiAddNewFormLevel";
import VcoiAddNewPermissions from "../../../Pages/VcoiSiteContent/VcoiAddNewPermission";
import VcoiSitePermission from "../../../Pages/VcoiSiteContent/VcoiSitePermission"
import VcoiManageEntity from "../../../Pages/VcoiSiteContent/VcoiManageEntity"
import VcoiAddNewEntity from "../../../Pages/VcoiSiteContent/VcoiAddNewEntity"
import VcoiManageEmailTemplateHome from "../../../Pages/VcoiSiteContent/VcoiManageEmailTemplateHome"
import VcoiManageEmailTemplate from "../../../Pages/VcoiSiteContent/VcoiManageEmailTemplate"

import VcoiNewPolicyAndEmailSettingHome from "../../../Pages/VcoiSiteContent/VcoiNewPolicyAndEmailSettingHome"
import VcoiManagePolicyAndEmailSetting from "../../../Pages/VcoiSiteContent/VcoiManagePolicyAndEmailSetting"
import VcoiInvitationReminder from "../../../Pages/VcoiSiteContent/VcoiInvitationReminder"
const DcoiRoutes = () => {
  return (
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/respondentsVcoi" element={<RespondentsVcoi />} />
        <Route path="/vcoisitecontent/VcoiSendInvitationReminder" element={<VcoiInvitationReminder />} />
        <Route path="/vcoisitecontent/VcoiAddNewPermission" element={<VcoiAddNewPermissions/>}/>
        <Route path="/vcoisitecontent/VcoiManageAdminPermission" element={<VcoiManageAdminPermission/>}/>
        <Route path="/vcoisitecontent/VcoiManagePolicyContent" element={<VcoiManagePolicyContent/>}/>
        <Route path="/vcoisitecontent/VcoiManagePolicyContentHome" element={<VcoiManagePolicyContentHome/>}/>
        <Route path="/vcoisitecontent/VcoiManageFormLabels" element={<VcoiManageFormLabels/>}/>
        <Route path="/vcoisitecontent/VcoiManageFormLabels/VcoiNewFormLabel" element={<VcoiAddNewFormLevel/>}/>
        <Route path="/Vcoisitecontent/VcoiSitePermission" element={<VcoiSitePermission/>}/>
        <Route path="/Vcoisitecontent/VcoiManageEntity" element={<VcoiManageEntity/>}/>
        <Route path="/Vcoisitecontent/VcoiAddNewEntity" element={<VcoiAddNewEntity/>}/> 
        <Route path="/Vcoisitecontent/VcoiManageEmailTemplateHome" element={<VcoiManageEmailTemplateHome/>}/> 
        <Route path="/Vcoisitecontent/VcoiManageEmailTemplate" element={<VcoiManageEmailTemplate/>}/> 


        
        <Route path="/Vcoisitecontent/VcoiNewPolicyAndEmailSettingHome" element={<VcoiNewPolicyAndEmailSettingHome/>}/> 
        <Route path="/Vcoisitecontent/VcoiManagePolicyAndEmailSetting" element={<VcoiManagePolicyAndEmailSetting/>}/> 

        
        
        
        {/* <Route path="/sitecontent/ManageEntity" element={<ManageEntity/>}/> */}
        {/* <Route path="/sitecontent/SendInvitationReminder" element={<InvitationReminder />} /> */}
        {/* <Route path="/sitecontent/ManageSubmissionCycle" element={<ManageSubmissionCycle />} />
        <Route path="/sitecontent/ManageEmailTemplate" element={<ManageEmailTemplate />} />
        <Route path="/sitecontent/ManageEmailTemplateHome" element={<ManageEmailTemplateHome />} />
        <Route path="/sitecontent/ViewArchives" element={<ViewArchives/>}/>
        <Route path="/sitecontent/InvitationReminder" element={<InvitationReminder/>}/>
        <Route path="/sitecontent/ManagePolicyContent" element={<ManagePolicyContent/>}/>
        <Route path="/sitecontent/ManagePolicyContentHome" element={<ManagePolicyContentHome/>}/>
        <Route path="/sitecontent/ManagePolicyAndEmailSetting" element={<ManagePolicyAndEmailSetting/>}/>
        <Route path="/sitecontent/NewPolicyAndEmailSettingHome" element={<NewPolicyAndEmailSettingHome/>}/>

        
        <Route path="/sitecontent/AddNewPermission" element={<AddNewPermission/>}/>
        <Route path="/sitecontent/ManageFormLabels" element={<ManageFormLabels/>}/>
        <Route path="/sitecontent/ManageEntity" element={<ManageEntity/>}/>
        <Route path="/sitecontent/SitePermission" element={<SitePermission/>}/>
        <Route path="/sitecontent/ManageFormLabels/NewFormLabel" element={<AddNewFormLevel/>}/>
      */}
      </Routes>
  );
};

export default DcoiRoutes;
